import AllSlotList from './AllSlotList';

const OverduePackages = () => <AllSlotList overdueOnly />;

export default OverduePackages;
